import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2';

const PaymentRequest = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [packages, setPackages] = useState([]);
    const [courses, setCourses] = useState([]);
    const [msg, setMsg] = useState("");

    const headerss = {
        accept: "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        Authorization: "Bearer " + user.token
    };

    const getCourseName = (courseId) => {
        const c = courses.find(x => x.id === Number(courseId));
        return c ? c.courseName : "-";
    };

    const handlePaymentStudent = async (e) => {
        e.preventDefault();
        //window.location.href = "/profile/odemetest/" + document.getElementById("studentpackageId").value;
        try {
            const res = await axios.post(
                //"https://localhost:7004/api/user/Subscription/Apply",
                "https://api.heryerdeingilizce.com/api/user/Subscription/Apply",
                {
                    gatewayId: 1,
                    package: document.getElementById("studentpackageId").value,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };
    const handlePaymentManager = async (e) => {
        e.preventDefault();
        //window.location.href = "/profile/odemetest/" + document.getElementById("studentpackageId").value;
        try {
            const res = await axios.post(
                //"https://localhost:7004/api/user/Subscription/Apply",
                "https://api.heryerdeingilizce.com/api/user/Subscription/Apply",
                {
                    gatewayId: 1,
                    package: document.getElementById("studentpackageId").value,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                setMsg(res.data.message);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };
    const handlePaymentStudentCoupen = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(
                //"https://localhost:7004/api/user/Subscription/ApplyCupon",
                "https://api.heryerdeingilizce.com/api/user/Subscription/ApplyCupon",
                {
                    packageId: document.getElementById("coupenpackageId").value,
                    cuponCode: document.getElementById("coupencode").value,
                },
                { headers: headerss }
            );

            if (res.data.success) {
                Swal.fire("Başarılı", "Ödeme talebiniz alınmıştır", "success");
            } else {
                Swal.fire("Hata", res.data.message, "error");
            }
        } catch (err) {
            setMsg(err.message);
        }
    };



    const fetchCourses = async () => {
        try {
            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Content/GetCourse",
                //"https://localhost:7004/api/user/Content/GetCourse",
                { headers: headerss }
            );

            if (res.data.success) {
                setCourses(res.data.data.courses || []);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const fetchDataPackages = async () => {
        try {
            const res = await axios.get(
                //"https://localhost:7004/api/User/GetPackages",
                "https://api.heryerdeingilizce.com/api/User/GetPackages",
                { headers: headerss }
            );

            if (res.data.success) {
                const filtered = res.data.data.filter(p =>
                    p.isActive &&
                    ((user.role === "Öğrenci" && p.isInvidual) ||
                        (user.role === "Yönetici" && !p.isInvidual))
                );
                setPackages(filtered);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    useEffect(() => {
        console.log(user)
        fetchCourses();
        fetchDataPackages();
    }, []);

    return (
        <div className="container my-4">
            <div className="card shadow-sm">
                <div className="card-body">
                    <h4 className="text-center mb-4">{t('paymentRequest')}</h4>

                    {msg && (
                        <div className="alert alert-warning text-center">{msg}</div>
                    )}

                    <div className="row g-4">

                        {/* SOL */}
                        <div className="col-md-6">
                            <div className="card h-100 border-secondary">
                                <div className="card-body">
                                    <h5 className="text-center mb-3">{t('usingpaymentmethod')}</h5>

                                    {user.user.roleName === "Student" && (
                                        <form onSubmit={handlePaymentStudent}>

                                            {/* <div className="mb-3">
                                                <label>{t('selectBank')}</label>
                                                <select id="studentbankId" className="form-select">
                                                    <option>{t('selectBank')}</option>
                                                    {banksdata.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.gatewayName} & {dt.typeName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div> */}
                                            <b>Seçim yaptıktan sonra Kredi Kartı Ödeme Sayfasına yönlendirileceksiniz.</b>
                                            <br /> <br />
                                            <div className="mb-3">
                                                <label>{t('selectPackage')}</label>
                                                <select id="studentpackageId" className="form-select">
                                                    <option>{t('selectPackage')}</option>
                                                    {packages.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: dt.packageName + " / " + getCourseName(dt.sortNumber)
                                                                }}
                                                            />
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <button className="btn btn-primary w-100">
                                                {t('continue')}
                                            </button>
                                        </form>
                                    )}
                                    {user.user.roleName === "Manager" && (
                                        <form onSubmit={handlePaymentManager}>

                                            {/* <div className="mb-3">
                                                <label>{t('selectBank')}</label>
                                                <select id="studentbankId" className="form-select">
                                                    <option>{t('selectBank')}</option>
                                                    {banksdata.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.gatewayName} & {dt.typeName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div> */}
                                            <br /> <br />
                                            <div className="mb-3">
                                                <label>{t('selectPackage')}</label>
                                                <select id="studentpackageId" className="form-select">
                                                    <option>{t('selectPackage')}</option>
                                                    {packages.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: dt.packageName + " / " + getCourseName(dt.sortNumber)
                                                                }}
                                                            />
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <button className="btn btn-primary w-100">
                                                {t('continue')}
                                            </button>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* SAĞ */}
                        <div className="col-md-6">
                            <div className="card h-100 border-secondary">
                                <div className="card-body">
                                    <h5 className="text-center mb-3">{t('usingcoupencode')}</h5>

                                    {user.user.roleName === "Student" && (
                                        <form onSubmit={handlePaymentStudentCoupen}>

                                            <div className="mb-3">
                                                <label>{t('selectPackage')}</label>
                                                <select id="coupenpackageId" className="form-select">
                                                    <option>{t('selectPackage')}</option>
                                                    {packages.map(dt => (
                                                        <option key={dt.id} value={dt.id}>
                                                            {dt.packageName} / {getCourseName(dt.sortNumber)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label>{t('coupencode')}</label>
                                                <textarea id="coupencode" className="form-control" required />
                                            </div>

                                            <button className="btn btn-success w-100">
                                                {t('create')}
                                            </button>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentRequest;